import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getMagentoSyncLogs = (params, onSuccess, onError) => {
    const response = axios.get('v1/admin/magento/sync-logs', { params });
    return handleResponse(response, onSuccess, onError);
};

export const syncMagentoManualBook = (payload = {}, onSuccess, onError) => {
    const response = axios.post('v1/admin/magento/sync-manual-book', payload, {
        timeout: 600000
    });
    return handleResponse(response, onSuccess, onError);
};

export const pullMagentoProducts = (payload = {}, onSuccess, onError) => {
    const response = axios.post('v1/admin/magento/pull-products', payload, {
        timeout: 600000
    });
    return handleResponse(response, onSuccess, onError);
};

export const getInitiateAllowedEmails = (onSuccess, onError) => {
    const response = axios.get('v1/admin/magento/allowed-initiate');
    return handleResponse(response, onSuccess, onError);
};

export const getMagentoSyncStatus = (onSuccess, onError) => {
    const response = axios.get('v1/admin/magento/sync-status');
    return handleResponse(response, onSuccess, onError);
};

export const resetMagentoSyncLock = (payload = {}, onSuccess, onError) => {
    const response = axios.post('v1/admin/magento/reset-sync-lock', payload);
    return handleResponse(response, onSuccess, onError);
};

export const rollbackMagentoManualBook = (payload = {}, onSuccess, onError) => {
    const response = axios.post('v1/admin/magento/rollback-manual-book', payload, {
        timeout: 600000
    });
    return handleResponse(response, onSuccess, onError);
};


